import { vnAppZone } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import { pageFactory } from "../modules/factory";

export class vnAppZoneSubHeader extends vnAppZone {

    public constructor(destination, appInterface: string | null = null) {
        super(destination, appInterface);
        this.zoneName = "SubHeader";
    }

    defineRoutes(appInterface) {

        let factory = new pageFactory();
        let _mythis = this;

        if (appInterface == 'dashboard') {

        } else {
            this.addForRoute('all', function () {

                // obtain the right module object
                let moduleObj = factory.get_actionHandler("subHeader", _mythis);

                // load it into the zone
                _mythis.loadModule(moduleObj);
            }, null);
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/vn_app_zone_subHeader.ts